<template>
  <div class="row">
    <div class="h-100 overflow-hidden placeholder-glow" style="height: 540px;">
      <iframe width="100%" height="540" v-if="link"
        :src="'https://www.youtube.com/embed/' + urlMontada + '?si=F0h37WXRniAE_agq&amp;controls=1&autoplay=' + autoplay + '&color=white'"
        title="YouTube video player" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen style="margin-top:-60px"></iframe>

      <template v-else>

      </template>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Youtube',
  props: {
    link: {
      default: null
    },
    ativa_placeholder: {
      default: false
    },
    autoplay: {
      default: 1
    },
  },
  computed: {
    class_placeholder: function () {
      return (this.ativa_placeholder ? 'placeholder' : '')
    },
    urlMontada: function () {
      if (this.link != '' && this.link != undefined) {
        if(this.link.includes('youtube.com')){
          var url = this.link.split('watch?v=')
          if (url[1] != undefined) {
            var uri = url[1].split('&')
            return uri[0]
          } else {
            return this.link;
          }
        } else if (this.link.includes('youtu.be')) {
          var url = this.link.split('youtu.be/')
          if (url[1] != undefined) {
            var uri = url[1].split('?')
            return uri[0]
          } else {
            return this.link;
          }
        }
      }
    }
  },
}
</script>

<style></style>